/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約単価
 */
export interface Sgkb575aResCtrTankaDto {
    /** 
     * 商品コード：半角英数混在
     */
    goodsCode?: string;
    /** 
     * 料金計算定義料金コード：半角英数混在
     */
    chargeCode?: string;
    /** 
     * 単価指定区分１：半角数字
     */
    tankaSiteiDiv1?: string;
    /** 
     * 単価指定区分２：半角数字
     */
    tankaSiteiDiv2?: string;
    /** 
     * 単価指定区分３：半角数字
     */
    tankaSiteiDiv3?: string;
    /** 
     * 単価指定区分４：半角数字
     */
    tankaSiteiDiv4?: string;
    /** 
     * 単価指定区分５：半角数字
     */
    tankaSiteiDiv5?: string;
    /** 
     * 契約単価正式名称：全角文字
     */
    ctrtnkAname?: string;
    /** 
     * 契約単価略称名称：全角文字
     */
    ctrtnkRyaku?: string;
    /** 
     * 単価範囲開始値：半角数値(小数点あり)
     */
    tankaRangeStart?: number;
    /** 
     * 単価範囲終了値：半角数値(小数点あり)
     */
    tankaRangeEnd?: number;
    /** 
     * 契約単価：半角数値(小数点あり)
     */
    tanka?: number;
    /** 
     * 調整単価コード：半角英数混在
     */
    choseiTankaCode?: string;
    /** 
     * 調整単価コード名称：全角半角混在
     */
    choseiTankaCodeAname?: string;
}
